/**
 * Created by jv on 15/05/2018.
 */
import utils from "Sources/utils/utils";
import CONSTANTS from "Sources/games/chicken-game/config/constants";

export default class Scoreboard extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "Scoreboard",
    });
  }

  init({ gameScene })
  {
    this.gameScene = gameScene;
    this.gameScene.events.off("game-time-updated").on("game-time-updated", time => this.setGameTime(time));
  }

  create()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;
    var spacing = 15;

    this.helpImageBtn = this.add.image(spacing, spacing, CONSTANTS.ATLAS_KEY, "misc/image_info.png").setOrigin(0, 0);
    this.helpBtnZone = this.add.zone(
      this.helpImageBtn.x - (this.helpImageBtn.width * this.helpImageBtn.originX) - 5,
      this.helpImageBtn.y - (this.helpImageBtn.height * this.helpImageBtn.originY) - 5,
      this.helpImageBtn.width + 10,
      this.helpImageBtn.height + 10
    )
      .setName("help-button")
      .setInteractive()
      .on("pointerup", () =>
      {
        this.input.mouse.target.style.cursor = "";
        this.gameScene.togglePause();
        this.showHelpScreen();
      })
      .on("pointerover", (e) =>
      {
        this.input.mouse.target.style.cursor = "pointer";
      })
      .on("pointerout", (e) =>
      {
        this.input.mouse.target.style.cursor = "";
      });

    this.scoreLabel = this.add.text(gameWidth - spacing, spacing - 10, "00:00", { fontFamily: "RabbitOnTheMoon", fontSize: 42, fontWeight: "normal", fill: "#89ae37" }).setOrigin(1, 0);

    if(this.gameScene.debug)
    {
      this._debugText = this.add.text(100, 20).setDepth(999);
      this._debugText.setShadow(1, 1, "#000000", true, false)
    }
  }

  setHelpButtonInteractive(flag)
  {
    if(flag !== false)
    {
      if(this.helpBtnZone)
      {
        this.helpBtnZone.setInteractive();
      }
    }
    else
    {
      if(this.helpBtnZone)
      {
        this.helpBtnZone.removeInteractive();
      }
    }
  }

  setGameTime(time)
  {
    this.scoreLabel.setText(utils.formatTime(time, "mm:ss"));
  }

  showHelpScreen()
  {
    this.helpBtnZone.removeInteractive();

    const menuScene = this.scene.get("Menu");
    menuScene.setVisible(true);
    menuScene.events.once("resume-btn-clicked", function()
    {
      this.helpBtnZone.setInteractive();
      menuScene.setInteractive(false).scene.setVisible(false);
      this.gameScene.togglePause();
    }, this);
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/scoreboard.js